const divConfirmCreateUser = {
  text: 'Cuenta creada con éxito',
  link: 'Link caducado'
};

export default divConfirmCreateUser;
